module.exports = __webpack_public_path__ + "img/bag-icon.7c698eee.svg";